<template>
    <dx-grid
        :url="url"
        :columns="columns"
        :title="title"
        :actions="actions"
        :onRowClicked="onRowClicked"
        navigationPath="onRowClicked"
        navigationField="onRowClicked"
        :beforeSetupGrid="beforeSetupGrid"
        :freezeHeader="true"
        ref="grid"
        :summaryOptions="{
            enabled: true,
            columns: [
                'price',
                'yeshivaKetanaCamp',
                'registrationFee',
                'transportationFee',
                'laundryFee',
                'discount',
            ],
        }"
        :expandedOptions="{
            enabled: true,
            allowExpandingAll: true,
            template: 'ykc-account-details',
        }"
    ></dx-grid>
</template>

<script>
import { formatCurrency } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "Billing Report",
        columns: [
            {
                field: "name",
                label: "Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "nameH",
                label: "Hebrew Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "familyID",
                label: "Account ID",
                link: "YKCAccountView",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "studentID",
                label: "Student ID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "class",
                label: "Class",
                format: "",
                type: "number",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "rateCode",
                label: "Rate Code",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "price",
                label: "Price",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "yeshivaKetanaCamp",
                label: "Yeshiva Ketana Camp",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "registrationFee",
                label: "Registration Fee",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "transportationFee",
                label: "Transportation Fee",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "laundryFee",
                label: "Laundry Fee",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "discount",
                label: "Discount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        actions: [],

        regID: "",
        url: "",
        phoneSearch: "",
    }),
    async created() {},
    methods: {
        async beforeSetupGrid() {
            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms.map((t) => t.term),
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.url = "yKCBilling?regID=" + this.regID;
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/yk/getRegID");
        },
        async getTerms() {
            return await this.$http.get("api/yk/getRegTerms");
        },
        async onRowClicked(row) {
            this.$router.push({
                name: "YKCAccountView",
                params: { id: row.familyID, reg_id: row.regID },
            });
        },
        onTermSelected(value) {
            this.regID = value;
            this.url = "yKCBilling?regID=" + this.regID;

            this.$refs.grid.reloadDataSource(this.url);
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
</style>
